import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell } from "../components/AuthShell";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell heading="Welcome to Maria's Forex / Crypto" subtitle="Private Currency & Cryptocurrency Market Dashboard">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        {error && <div className="border border-danger/40 bg-danger/10 text-danger text-sm px-3 py-2" data-testid="login-error">{error}</div>}
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" placeholder="you@example.com" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-xs text-primary hover:underline" data-testid="forgot-link">Forgot password?</Link>
          </div>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" placeholder="••••••••" />
        </div>
        <Button type="submit" className="w-full rounded-none h-11" disabled={loading} data-testid="login-submit">
          {loading ? "Signing in…" : "Sign In"}
        </Button>
        <p className="text-sm text-muted-foreground text-center">
          Have an invitation code?{" "}
          <Link to="/register" className="text-primary hover:underline font-medium" data-testid="register-link">Create account</Link>
        </p>
      </form>
    </AuthShell>
  );
}
